module.exports = __webpack_public_path__ + "media/images/news/qq-3310a00e95e839ac5fb8542f5d98276d.png";